import React from 'react';
import Table from '../../components/common/Table';
import { FirearmBarrelDTO } from '../../services/apiClient';
import { renderBooleanBadge } from '../../utils/displayUtils';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface FirearmBarrelTableProps {
  data: FirearmBarrelDTO[];
  handleEdit: (row: FirearmBarrelDTO) => void;
  handleDelete: (row: FirearmBarrelDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const FirearmBarrelTable: React.FC<FirearmBarrelTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: FirearmBarrelDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Position',
          key: 'displayPosition',
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (createdUtc: Date) =>
            convertToUserTime(createdUtc?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default FirearmBarrelTable;
